import type { InfoPopupModelSlice } from './infoPopupState';

export function toggleInfoPopup(model: InfoPopupModelSlice): void {
  model.setInfoOpen((open) => !open);
  model.onInfoClick?.();
}

export function closeInfoPopup(model: InfoPopupModelSlice): void {
  model.setInfoOpen(false);
}
